"use strict";

function _instanceof(left, right) { if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) { return !!right[Symbol.hasInstance](left); } else { return left instanceof right; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports["vue-puzzle-vcode"] = e() : t["vue-puzzle-vcode"] = e();
}(void 0, function () {
  return function () {
    "use strict";

    var t = {
        667: function _(t, e, n) {
          n.r(e), n.d(e, {
            default: function _default() {
              return l;
            }
          });

          var i = function i() {
            var t = this,
              e = t.$createElement,
              n = t._self._c || e;
            return n("div", {
              class: ["vue-puzzle-vcode", {
                show_: t.show
              }],
              attrs: {
                id: t.id
              },
              on: {
                mousedown: t.onCloseMouseDown,
                mouseup: t.onCloseMouseUp,
                touchstart: t.onCloseMouseDown,
                touchend: t.onCloseMouseUp
              }
            }, [n("div", {
              staticClass: "vue-auth-box_",
              on: {
                mousedown: function mousedown(t) {
                  t.stopPropagation();
                },
                touchstart: function touchstart(t) {
                  t.stopPropagation();
                }
              }
            }, [n("div", {
              staticClass: "auth-body_",
              style: "height: " + t.canvasHeight + "px"
            }, [n("canvas", {
              ref: "canvas1",
              style: "width:" + t.canvasWidth + "px;height:" + t.canvasHeight + "px",
              attrs: {
                width: t.canvasWidth,
                height: t.canvasHeight
              }
            }), t._v(" "), n("canvas", {
              ref: "canvas3",
              class: ["auth-canvas3_", {
                show: t.isSuccess
              }],
              style: "width:" + t.canvasWidth + "px;height:" + t.canvasHeight + "px",
              attrs: {
                width: t.canvasWidth,
                height: t.canvasHeight
              }
            }), t._v(" "), n("canvas", {
              ref: "canvas2",
              staticClass: "auth-canvas2_",
              style: "width:" + t.puzzleBaseSize + "px;height:" + t.canvasHeight + "px;transform:translateX(" + (t.styleWidth - t.sliderBaseSize - (t.puzzleBaseSize - t.sliderBaseSize) * ((t.styleWidth - t.sliderBaseSize) / (t.canvasWidth - t.sliderBaseSize))) + "px)",
              attrs: {
                width: t.puzzleBaseSize,
                height: t.canvasHeight
              }
            }), t._v(" "), n("div", {
              class: ["loading-box_", {
                hide_: !t.loading
              }]
            }, [t._m(0)]), t._v(" "), n("div", {
              class: ["info-box_", {
                show: t.infoBoxShow
              }, {
                fail: t.infoBoxFail
              }]
            }, [t._v("\n        " + t._s(t.infoText) + "\n      ")]), t._v(" "), n("div", {
              class: ["flash_", {
                show: t.isSuccess
              }],
              style: "transform: translateX(" + (t.isSuccess ? t.canvasWidth + .578 * t.canvasHeight + "px" : "-" + .578 * t.canvasHeight + "px") + ") skew(-30deg, 0);"
            }), t._v(" "), n("img", {
              staticClass: "reset_",
              attrs: {
                src: t.resetSvg
              },
              on: {
                click: t.reset
              }
            })]), t._v(" "), n("div", {
              staticClass: "auth-control_"
            }, [n("div", {
              staticClass: "range-box",
              style: "height:" + t.sliderBaseSize + "px"
            }, [n("div", {
              staticClass: "range-text"
            }, [t._v(t._s(t.sliderText))]), t._v(" "), n("div", {
              ref: "range-slider",
              staticClass: "range-slider",
              style: "width:" + t.styleWidth + "px"
            }, [n("div", {
              class: ["range-btn", {
                isDown: t.mouseDown
              }],
              style: "width:" + t.sliderBaseSize + "px",
              on: {
                mousedown: function mousedown(e) {
                  return t.onRangeMouseDown(e);
                },
                touchstart: function touchstart(e) {
                  return t.onRangeMouseDown(e);
                }
              }
            }, [n("div"), t._v(" "), n("div"), t._v(" "), n("div")])])])])])]);
          };

          i._withStripped = !0;
          var o = {
              data: function data() {
                return {
                  mouseDown: !1,
                  startWidth: 50,
                  startX: 0,
                  newX: 0,
                  pinX: 0,
                  pinY: 0,
                  loading: !0,
                  isCanSlide: !1,
                  error: !1,
                  infoBoxShow: !1,
                  infoText: "",
                  infoBoxFail: !1,
                  timer1: null,
                  closeDown: !1,
                  isSuccess: !1,
                  resetSvg: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAELklEQVRYR+2YW2wUZRTH//9vtlCoF9IoIklT3PqgPGi326hoetuaGEhIr9SgCYkkgt2WGOQVCca+GavWdr0GjD4YhG3RB3hply1LQA1tEQIxEXapGI2pEkys9LIzx2ylYWfY6e5sF0oi+7hzzvl+3/9855xvhrjNf7zN+XAHcL4Z+n8o6JWTeYt++W25S596AIZy6TB+n3yo+Nchlk8vmIIVowdXU9c3Q1gDSilBlQwjgBAYFGDvdF58/4milqvZwDpOcXWsb5Uh8hmBqkwXFMhlCN8aX5LXNbRy/T+Z+iXsHAFWRXs3QGQPyLucLDJrK5DgUXdTsxPfjAEro8E3Ce50EtxsKxPTwCPH3U2jTmJkBJgWTnAMxDeGMEoa0xQ+LJQnCD4HYFkCyAC3RdwN3U7gMkpxRTTYrMD91sCJIgCxV5R6O1Jcfy7VwonqLoj9/CqB2kF341qncGkBvRe+ureAWpRgoalCBecMFzcdK24YymZRJz5zprgq1tsJwXYL3CVZGvdGHmwZc7JQtra2gE+f712ep2QUYP714DJhaJrXLqXZQszlZwtYdSHoB9ljVk/ePVrSZFL0ZkAlxzQBVseCT8WhZhRThtFB8plk9Zi/qCi8cv0fNxvKFrDy4oF11NXXIFy2EII4iBcG3Y03VLZT8OqRd5aFPduvOEpxRayvXolxAKB2g6NgEhobBlc1HHYKY7WvHf5wtVAPgegIlbbZ9seUZ7AyFnwewi9pGoUyDmhrB931kfnC1ZwOeKlLP8GZJi6QLSFP2yep4toXSbT3ZQAfX3O6omt8Nhd9r/aHQAUMOQywYBZo5uZD2ThQ2rbPCjlnH6yI9rUryE5DU75ctJaake46Be4DuDjF8dFBNA94/AdtiySVxIlpMlTS8td801o70vMigM9huTda2lhcKHVHPO2HZv/P6LIwX7hk/+qzPSvUJGMkrg8AQYTkroRdXMlE+HH/twsG6BsOdJHYZlaO/lBZ6weOiiSXqs3Gqj0TeAxx+T75DIpgwjC0onD51pQD4JaluPrkR/cpFT9DcoVp84LOgTL/DjtBbglgou+puHwB8lEznPxJw1XSX77VtgizBvQNBw4RMqB7xt4Lc3c8lQKJaQHoO4R8ydz0/7MWoCXk8c85MrMC9J3qaafw/WtQlwXST+F3BnAeYB4obgJ1BJIuG+YtiKAjVOZ/Pd1ZdwzoG+4uBtSPpjaRbhXLcwF3hzytb2TilgVgT5BkYybBrTYC+Rvg5nRpdTRJrIs8+VPXPQXj2i4ItxC4O2NQQUQnN4U9rRcz9nH64p4ceM2lziX5Y4s3KHCdUHwE77ecMkMEp6BwhIa2Z6DslZRvfulgHafYLuCas58WLp2aLCFUga70qxOFU6dPFL2W1feYeaU43Y5z/TxnCuYabMEuC043ckdBp4pZ7f8FE5psOI1g6fwAAAAASUVORK5CYII=",
                  imgIndex: -1
                };
              },
              props: {
                id: {
                  type: String
                },
                canvasWidth: {
                  type: Number,
                  default: 310
                },
                canvasHeight: {
                  type: Number,
                  default: 160
                },
                show: {
                  type: Boolean,
                  default: !1
                },
                puzzleScale: {
                  type: Number,
                  default: 1
                },
                sliderSize: {
                  type: Number,
                  default: 50
                },
                range: {
                  type: Number,
                  default: 10
                },
                imgs: {
                  type: Array
                },
                successText: {
                  type: String,
                  default: "验证通过！"
                },
                failText: {
                  type: String,
                  default: "验证失败，请重试"
                },
                sliderText: {
                  type: String,
                  default: "拖动滑块完成拼图"
                }
              },
              mounted: function mounted() {
                document.body.appendChild(this.$el), document.addEventListener("mousemove", this.onRangeMouseMove, !1), document.addEventListener("mouseup", this.onRangeMouseUp, !1), document.addEventListener("touchmove", this.onRangeMouseMove, {
                  passive: !1
                }), document.addEventListener("touchend", this.onRangeMouseUp, !1), this.show && document.body.classList.add("vue-puzzle-overflow"), this.reset();
              },
              beforeDestroy: function beforeDestroy() {
                clearTimeout(this.timer1), document.body.removeChild(this.$el), document.removeEventListener("mousemove", this.onRangeMouseMove, !1), document.removeEventListener("mouseup", this.onRangeMouseUp, !1), document.removeEventListener("touchmove", this.onRangeMouseMove, {
                  passive: !1
                }), document.removeEventListener("touchend", this.onRangeMouseUp, !1);
              },
              watch: {
                show: function show(t) {
                  t ? (document.body.classList.add("vue-puzzle-overflow"), this.reset()) : document.body.classList.remove("vue-puzzle-overflow");
                }
              },
              computed: {
                styleWidth: function styleWidth() {
                  var t = this.startWidth + this.newX - this.startX;
                  return t < this.sliderBaseSize ? this.sliderBaseSize : t > this.canvasWidth ? this.canvasWidth : t;
                },
                puzzleBaseSize: function puzzleBaseSize() {
                  return Math.round(52.5 * Math.max(Math.min(this.puzzleScale, 2), .2) + 6);
                },
                sliderBaseSize: function sliderBaseSize() {
                  return Math.max(Math.min(Math.round(this.sliderSize), Math.round(.5 * this.canvasWidth)), 10);
                }
              },
              methods: {
                onClose: function onClose() {
                  this.mouseDown || (clearTimeout(this.timer1), this.$emit("close"));
                },
                onCloseMouseDown: function onCloseMouseDown() {
                  this.closeDown = !0;
                },
                onCloseMouseUp: function onCloseMouseUp() {
                  this.closeDown && this.onClose(), this.closeDown = !1;
                },
                onRangeMouseDown: function onRangeMouseDown(t) {
                  this.isCanSlide && (this.mouseDown = !0, this.startWidth = this.$refs["range-slider"].clientWidth, this.newX = t.clientX || t.changedTouches[0].clientX, this.startX = t.clientX || t.changedTouches[0].clientX);
                },
                onRangeMouseMove: function onRangeMouseMove(t) {
                  this.mouseDown && (t.preventDefault(), this.newX = t.clientX || t.changedTouches[0].clientX);
                },
                onRangeMouseUp: function onRangeMouseUp() {
                  this.mouseDown && (this.mouseDown = !1, this.submit());
                },
                init: function init(t) {
                  var _this = this;

                  this.loading = !0, this.isCanSlide = !1;
                  var e = this.$refs.canvas1,
                    n = this.$refs.canvas2,
                    i = this.$refs.canvas3,
                    o = e.getContext("2d"),
                    a = n.getContext("2d"),
                    s = i.getContext("2d"),
                    r = document.createElement("img");

                  if (o.clearRect(0, 0, this.canvasWidth, this.canvasHeight), a.clearRect(0, 0, this.canvasWidth, this.canvasHeight), this.pinX = this.getRandom(this.puzzleBaseSize, this.canvasWidth - this.puzzleBaseSize - 20), this.pinY = this.getRandom(20, this.canvasHeight - this.puzzleBaseSize - 20), r.crossOrigin = "anonymous", r.onload = function () {
                    var _this$makeImgSize = _this.makeImgSize(r),
                      _this$makeImgSize2 = _slicedToArray(_this$makeImgSize, 4),
                      t = _this$makeImgSize2[0],
                      e = _this$makeImgSize2[1],
                      n = _this$makeImgSize2[2],
                      i = _this$makeImgSize2[3];

                    o.save(), _this.paintBrick(o), o.closePath(), navigator.userAgent.indexOf("Firefox") >= 0 && navigator.userAgent.indexOf("Windows") >= 0 || (o.shadowOffsetX = 0, o.shadowOffsetY = 0, o.shadowColor = "#000", o.shadowBlur = 3, o.fill()), o.clip(), o.save(), o.shadowOffsetX = 0, o.shadowOffsetY = 0, o.shadowColor = "#000", o.shadowBlur = 2, o.fill(), o.restore(), o.drawImage(r, t, e, n, i), s.drawImage(r, t, e, n, i), o.globalCompositeOperation = "source-atop", _this.paintBrick(o), o.arc(_this.pinX + Math.ceil(_this.puzzleBaseSize / 2), _this.pinY + Math.ceil(_this.puzzleBaseSize / 2), 1.2 * _this.puzzleBaseSize, 0, 2 * Math.PI, !0), o.closePath(), o.shadowColor = "rgba(255, 255, 255, .8)", o.shadowOffsetX = -1, o.shadowOffsetY = -1, o.shadowBlur = Math.min(Math.ceil(8 * _this.puzzleScale), 12), o.fillStyle = "#ffffaa", o.fill();
                    var h = o.getImageData(_this.pinX - 3, _this.pinY - 20, _this.pinX + _this.puzzleBaseSize + 5, _this.pinY + _this.puzzleBaseSize + 5);
                    a.putImageData(h, 0, _this.pinY - 20), o.restore(), o.clearRect(0, 0, _this.canvasWidth, _this.canvasHeight), o.save(), _this.paintBrick(o), o.globalAlpha = .8, o.fillStyle = "#ffffff", o.fill(), o.restore(), o.save(), o.globalCompositeOperation = "source-atop", _this.paintBrick(o), o.arc(_this.pinX + Math.ceil(_this.puzzleBaseSize / 2), _this.pinY + Math.ceil(_this.puzzleBaseSize / 2), 1.2 * _this.puzzleBaseSize, 0, 2 * Math.PI, !0), o.shadowColor = "#000", o.shadowOffsetX = 2, o.shadowOffsetY = 2, o.shadowBlur = 16, o.fill(), o.restore(), o.save(), o.globalCompositeOperation = "destination-over", o.drawImage(r, t, e, n, i), o.restore(), _this.loading = !1, _this.isCanSlide = !0;
                  }, r.onerror = function () {
                    _this.init(!0);
                  }, !t && this.imgs && this.imgs.length) {
                    var _t = this.getRandom(0, this.imgs.length - 1);

                    _t === this.imgIndex && (_t === this.imgs.length - 1 ? _t = 0 : _t++), this.imgIndex = _t, r.src = this.imgs[_t];
                  } else r.src = this.makeImgWithCanvas();
                },
                getRandom: function getRandom(t, e) {
                  return Math.ceil(Math.random() * (e - t) + t);
                },
                makeImgSize: function makeImgSize(t) {
                  var e = t.width / t.height;
                  var n = 0,
                    i = 0,
                    o = 0,
                    a = 0;
                  return e > this.canvasWidth / this.canvasHeight ? (a = this.canvasHeight, o = e * a, i = 0, n = (this.canvasWidth - o) / 2) : (o = this.canvasWidth, a = o / e, n = 0, i = (this.canvasHeight - a) / 2), [n, i, o, a];
                },
                paintBrick: function paintBrick(t) {
                  var e = Math.ceil(15 * this.puzzleScale);
                  t.beginPath(), t.moveTo(this.pinX, this.pinY), t.lineTo(this.pinX + e, this.pinY), t.arcTo(this.pinX + e, this.pinY - e / 2, this.pinX + e + e / 2, this.pinY - e / 2, e / 2), t.arcTo(this.pinX + e + e, this.pinY - e / 2, this.pinX + e + e, this.pinY, e / 2), t.lineTo(this.pinX + e + e + e, this.pinY), t.lineTo(this.pinX + e + e + e, this.pinY + e), t.arcTo(this.pinX + e + e + e + e / 2, this.pinY + e, this.pinX + e + e + e + e / 2, this.pinY + e + e / 2, e / 2), t.arcTo(this.pinX + e + e + e + e / 2, this.pinY + e + e, this.pinX + e + e + e, this.pinY + e + e, e / 2), t.lineTo(this.pinX + e + e + e, this.pinY + e + e + e), t.lineTo(this.pinX, this.pinY + e + e + e), t.lineTo(this.pinX, this.pinY + e + e), t.arcTo(this.pinX + e / 2, this.pinY + e + e, this.pinX + e / 2, this.pinY + e + e / 2, e / 2), t.arcTo(this.pinX + e / 2, this.pinY + e, this.pinX, this.pinY + e, e / 2), t.lineTo(this.pinX, this.pinY);
                },
                makeImgWithCanvas: function makeImgWithCanvas() {
                  var t = document.createElement("canvas"),
                    e = t.getContext("2d");
                  t.width = this.canvasWidth, t.height = this.canvasHeight, e.fillStyle = "rgb(".concat(this.getRandom(100, 255), ",").concat(this.getRandom(100, 255), ",").concat(this.getRandom(100, 255), ")"), e.fillRect(0, 0, this.canvasWidth, this.canvasHeight);

                  for (var _n2 = 0; _n2 < 12; _n2++) {
                    if (e.fillStyle = "rgb(".concat(this.getRandom(100, 255), ",").concat(this.getRandom(100, 255), ",").concat(this.getRandom(100, 255), ")"), e.strokeStyle = "rgb(".concat(this.getRandom(100, 255), ",").concat(this.getRandom(100, 255), ",").concat(this.getRandom(100, 255), ")"), this.getRandom(0, 2) > 1) e.save(), e.rotate(this.getRandom(-90, 90) * Math.PI / 180), e.fillRect(this.getRandom(-20, t.width - 20), this.getRandom(-20, t.height - 20), this.getRandom(10, t.width / 2 + 10), this.getRandom(10, t.height / 2 + 10)), e.restore();else {
                      e.beginPath();

                      var _n3 = this.getRandom(-Math.PI, Math.PI);

                      e.arc(this.getRandom(0, t.width), this.getRandom(0, t.height), this.getRandom(10, t.height / 2 + 10), _n3, _n3 + 1.5 * Math.PI), e.closePath(), e.fill();
                    }
                  }

                  return t.toDataURL("image/png");
                },
                submit: function submit() {
                  var _this2 = this;

                  var t = Math.abs(this.pinX - (this.styleWidth - this.sliderBaseSize) + (this.puzzleBaseSize - this.sliderBaseSize) * ((this.styleWidth - this.sliderBaseSize) / (this.canvasWidth - this.sliderBaseSize)) - 3);
                  t < this.range ? (this.infoText = this.successText, this.infoBoxFail = !1, this.infoBoxShow = !0, this.isCanSlide = !1, this.isSuccess = !0, clearTimeout(this.timer1), this.timer1 = setTimeout(function () {
                    _this2.$emit("success", t);
                  }, 800)) : (this.infoText = this.failText, this.infoBoxFail = !0, this.infoBoxShow = !0, this.isCanSlide = !1, this.$emit("fail", t), clearTimeout(this.timer1), this.timer1 = setTimeout(function () {
                    _this2.reset();
                  }, 800));
                },
                reset: function reset() {
                  this.infoBoxFail = !1, this.infoBoxShow = !1, this.isCanSlide = !0, this.isSuccess = !1, this.startWidth = this.sliderBaseSize, this.startX = 0, this.newX = 0, this.init();
                }
              }
            },
            a = n(379),
            s = n.n(a),
            r = n(358);
          s()(r.Z, {
            insert: "head",
            singleton: !1
          }), r.Z.locals;

          var h = function (t, e, n, i, o, a, s, r) {
            var h,
              l = "function" == typeof t ? t.options : t;
            if (e && (l.render = e, l.staticRenderFns = [function () {
              var t = this,
                e = t.$createElement,
                n = t._self._c || e;
              return n("div", {
                staticClass: "loading-gif_"
              }, [n("span"), t._v(" "), n("span"), t._v(" "), n("span"), t._v(" "), n("span"), t._v(" "), n("span")]);
            }], l._compiled = !0), h) if (l.functional) {
              l._injectStyles = h;
              var d = l.render;

              l.render = function (t, e) {
                return h.call(e), d(t, e);
              };
            } else {
              var c = l.beforeCreate;
              l.beforeCreate = c ? [].concat(c, h) : [h];
            }
            return {
              exports: t,
              options: l
            };
          }(o, i);

          h.options.__file = "src/app.vue";
          var l = h.exports;
        },
        358: function _(t, e, n) {
          var i = n(645),
            o = n.n(i)()(function (t) {
              return t[1];
            });
          o.push([t.id, ".vue-puzzle-vcode {\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background-color: rgba(0, 0, 0, 0.3);\n  z-index: 999;\n  opacity: 0;\n  pointer-events: none;\n  -webkit-transition: opacity 200ms;\n  transition: opacity 200ms;\n}\n.vue-puzzle-vcode.show_ {\n  opacity: 1;\n  pointer-events: auto;\n}\n.vue-auth-box_ {\n  position: absolute;\n  top: 40%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  padding: 20px;\n  background: #fff;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  border-radius: 3px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n}\n.vue-auth-box_ .auth-body_ {\n  position: relative;\n  overflow: hidden;\n  border-radius: 3px;\n}\n.vue-auth-box_ .auth-body_ .loading-box_ {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background-color: rgba(0, 0, 0, 0.8);\n  z-index: 20;\n  opacity: 1;\n  -webkit-transition: opacity 200ms;\n  transition: opacity 200ms;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n          align-items: center;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n          justify-content: center;\n}\n.vue-auth-box_ .auth-body_ .loading-box_.hide_ {\n  opacity: 0;\n  pointer-events: none;\n}\n.vue-auth-box_ .auth-body_ .loading-box_.hide_ .loading-gif_ span {\n  -webkit-animation-play-state: paused;\n          animation-play-state: paused;\n}\n.vue-auth-box_ .auth-body_ .loading-box_ .loading-gif_ {\n  -webkit-box-flex: 0;\n  -webkit-flex: none;\n          flex: none;\n  height: 5px;\n  line-height: 0;\n}\n@-webkit-keyframes load {\n0% {\n    opacity: 1;\n    -webkit-transform: scale(1.3);\n            transform: scale(1.3);\n}\n100% {\n    opacity: 0.2;\n    -webkit-transform: scale(0.3);\n            transform: scale(0.3);\n}\n}\n@keyframes load {\n0% {\n    opacity: 1;\n    -webkit-transform: scale(1.3);\n            transform: scale(1.3);\n}\n100% {\n    opacity: 0.2;\n    -webkit-transform: scale(0.3);\n            transform: scale(0.3);\n}\n}\n.vue-auth-box_ .auth-body_ .loading-box_ .loading-gif_ span {\n  display: inline-block;\n  width: 5px;\n  height: 100%;\n  margin-left: 2px;\n  border-radius: 50%;\n  background-color: #888;\n  -webkit-animation: load 1.04s ease infinite;\n          animation: load 1.04s ease infinite;\n}\n.vue-auth-box_ .auth-body_ .loading-box_ .loading-gif_ span:nth-child(1) {\n  margin-left: 0;\n}\n.vue-auth-box_ .auth-body_ .loading-box_ .loading-gif_ span:nth-child(2) {\n  -webkit-animation-delay: 0.13s;\n          animation-delay: 0.13s;\n}\n.vue-auth-box_ .auth-body_ .loading-box_ .loading-gif_ span:nth-child(3) {\n  -webkit-animation-delay: 0.26s;\n          animation-delay: 0.26s;\n}\n.vue-auth-box_ .auth-body_ .loading-box_ .loading-gif_ span:nth-child(4) {\n  -webkit-animation-delay: 0.39s;\n          animation-delay: 0.39s;\n}\n.vue-auth-box_ .auth-body_ .loading-box_ .loading-gif_ span:nth-child(5) {\n  -webkit-animation-delay: 0.52s;\n          animation-delay: 0.52s;\n}\n.vue-auth-box_ .auth-body_ .info-box_ {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 24px;\n  line-height: 24px;\n  text-align: center;\n  overflow: hidden;\n  font-size: 13px;\n  background-color: #83ce3f;\n  opacity: 0;\n  -webkit-transform: translateY(24px);\n          transform: translateY(24px);\n  -webkit-transition: all 200ms;\n  transition: all 200ms;\n  color: #fff;\n  z-index: 10;\n}\n.vue-auth-box_ .auth-body_ .info-box_.show {\n  opacity: 0.95;\n  -webkit-transform: translateY(0);\n          transform: translateY(0);\n}\n.vue-auth-box_ .auth-body_ .info-box_.fail {\n  background-color: #ce594b;\n}\n.vue-auth-box_ .auth-body_ .auth-canvas2_ {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 60px;\n  height: 100%;\n  z-index: 2;\n}\n.vue-auth-box_ .auth-body_ .auth-canvas3_ {\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  -webkit-transition: opacity 600ms;\n  transition: opacity 600ms;\n  z-index: 3;\n}\n.vue-auth-box_ .auth-body_ .auth-canvas3_.show {\n  opacity: 1;\n}\n.vue-auth-box_ .auth-body_ .flash_ {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 30px;\n  height: 100%;\n  background-color: rgba(255, 255, 255, 0.1);\n  z-index: 3;\n}\n.vue-auth-box_ .auth-body_ .flash_.show {\n  -webkit-transition: -webkit-transform 600ms;\n  transition: -webkit-transform 600ms;\n  transition: transform 600ms;\n  transition: transform 600ms, -webkit-transform 600ms;\n}\n.vue-auth-box_ .auth-body_ .reset_ {\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  width: 35px;\n  height: auto;\n  z-index: 12;\n  cursor: pointer;\n  -webkit-transition: -webkit-transform 200ms;\n  transition: -webkit-transform 200ms;\n  transition: transform 200ms;\n  transition: transform 200ms, -webkit-transform 200ms;\n  -webkit-transform: rotate(0deg);\n          transform: rotate(0deg);\n}\n.vue-auth-box_ .auth-body_ .reset_:hover {\n  -webkit-transform: rotate(-90deg);\n          transform: rotate(-90deg);\n}\n.vue-auth-box_ .auth-control_ .range-box {\n  position: relative;\n  width: 100%;\n  background-color: #eef1f8;\n  margin-top: 20px;\n  border-radius: 3px;\n  box-shadow: 0 0 8px rgba(240, 240, 240, 0.6) inset;\n}\n.vue-auth-box_ .auth-control_ .range-box .range-text {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  font-size: 14px;\n  color: #b7bcd1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-align: center;\n  width: 100%;\n}\n.vue-auth-box_ .auth-control_ .range-box .range-slider {\n  position: absolute;\n  height: 100%;\n  width: 50px;\n  background-color: rgba(106, 160, 255, 0.8);\n  border-radius: 3px;\n}\n.vue-auth-box_ .auth-control_ .range-box .range-slider .range-btn {\n  position: absolute;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n          align-items: center;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n          justify-content: center;\n  right: 0;\n  width: 50px;\n  height: 100%;\n  background-color: #fff;\n  border-radius: 3px;\n  box-shadow: 0 0 4px #ccc;\n  cursor: pointer;\n}\n.vue-auth-box_ .auth-control_ .range-box .range-slider .range-btn > div {\n  width: 0;\n  height: 40%;\n  -webkit-transition: all 200ms;\n  transition: all 200ms;\n  border: solid 1px #6aa0ff;\n}\n.vue-auth-box_ .auth-control_ .range-box .range-slider .range-btn > div:nth-child(2) {\n  margin: 0 4px;\n}\n.vue-auth-box_ .auth-control_ .range-box .range-slider .range-btn:hover > div:first-child,\n.vue-auth-box_ .auth-control_ .range-box .range-slider .range-btn.isDown > div:first-child {\n  border: solid 4px transparent;\n  height: 0;\n  border-right-color: #6aa0ff;\n}\n.vue-auth-box_ .auth-control_ .range-box .range-slider .range-btn:hover > div:nth-child(2),\n.vue-auth-box_ .auth-control_ .range-box .range-slider .range-btn.isDown > div:nth-child(2) {\n  border-width: 3px;\n  height: 0;\n  border-radius: 3px;\n  margin: 0 6px;\n  border-right-color: #6aa0ff;\n}\n.vue-auth-box_ .auth-control_ .range-box .range-slider .range-btn:hover > div:nth-child(3),\n.vue-auth-box_ .auth-control_ .range-box .range-slider .range-btn.isDown > div:nth-child(3) {\n  border: solid 4px transparent;\n  height: 0;\n  border-left-color: #6aa0ff;\n}\n.vue-puzzle-overflow {\n  overflow: hidden !important;\n}\n", ""]), e.Z = o;
        },
        645: function _(t) {
          t.exports = function (t) {
            var e = [];
            return e.toString = function () {
              return this.map(function (e) {
                var n = t(e);
                return e[2] ? "@media ".concat(e[2], " {").concat(n, "}") : n;
              }).join("");
            }, e.i = function (t, n, i) {
              "string" == typeof t && (t = [[null, t, ""]]);
              var o = {};
              if (i) for (var a = 0; a < this.length; a++) {
                var s = this[a][0];
                null != s && (o[s] = !0);
              }

              for (var r = 0; r < t.length; r++) {
                var h = [].concat(t[r]);
                i && o[h[0]] || (n && (h[2] ? h[2] = "".concat(n, " and ").concat(h[2]) : h[2] = n), e.push(h));
              }
            }, e;
          };
        },
        379: function _(t, e, n) {
          var i,
            o = function () {
              var t = {};
              return function (e) {
                if (void 0 === t[e]) {
                  var n = document.querySelector(e);
                  if (window.HTMLIFrameElement && _instanceof(n, window.HTMLIFrameElement)) try {
                    n = n.contentDocument.head;
                  } catch (t) {
                    n = null;
                  }
                  t[e] = n;
                }

                return t[e];
              };
            }(),
            a = [];

          function s(t) {
            for (var e = -1, n = 0; n < a.length; n++) {
              if (a[n].identifier === t) {
                e = n;
                break;
              }
            }

            return e;
          }

          function r(t, e) {
            for (var n = {}, i = [], o = 0; o < t.length; o++) {
              var r = t[o],
                h = e.base ? r[0] + e.base : r[0],
                l = n[h] || 0,
                d = "".concat(h, " ").concat(l);
              n[h] = l + 1;
              var c = s(d),
                u = {
                  css: r[1],
                  media: r[2],
                  sourceMap: r[3]
                };
              -1 !== c ? (a[c].references++, a[c].updater(u)) : a.push({
                identifier: d,
                updater: g(u, e),
                references: 1
              }), i.push(d);
            }

            return i;
          }

          function h(t) {
            var e = document.createElement("style"),
              i = t.attributes || {};

            if (void 0 === i.nonce) {
              var a = n.nc;
              a && (i.nonce = a);
            }

            if (Object.keys(i).forEach(function (t) {
              e.setAttribute(t, i[t]);
            }), "function" == typeof t.insert) t.insert(e);else {
              var s = o(t.insert || "head");
              if (!s) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
              s.appendChild(e);
            }
            return e;
          }

          var l,
            d = (l = [], function (t, e) {
              return l[t] = e, l.filter(Boolean).join("\n");
            });

          function c(t, e, n, i) {
            var o = n ? "" : i.media ? "@media ".concat(i.media, " {").concat(i.css, "}") : i.css;
            if (t.styleSheet) t.styleSheet.cssText = d(e, o);else {
              var a = document.createTextNode(o),
                s = t.childNodes;
              s[e] && t.removeChild(s[e]), s.length ? t.insertBefore(a, s[e]) : t.appendChild(a);
            }
          }

          function u(t, e, n) {
            var i = n.css,
              o = n.media,
              a = n.sourceMap;
            if (o ? t.setAttribute("media", o) : t.removeAttribute("media"), a && "undefined" != typeof btoa && (i += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(a)))), " */")), t.styleSheet) t.styleSheet.cssText = i;else {
              for (; t.firstChild;) {
                t.removeChild(t.firstChild);
              }

              t.appendChild(document.createTextNode(i));
            }
          }

          var p = null,
            f = 0;

          function g(t, e) {
            var n, i, o;

            if (e.singleton) {
              var a = f++;
              n = p || (p = h(e)), i = c.bind(null, n, a, !1), o = c.bind(null, n, a, !0);
            } else n = h(e), i = u.bind(null, n, e), o = function o() {
              !function (t) {
                if (null === t.parentNode) return !1;
                t.parentNode.removeChild(t);
              }(n);
            };

            return i(t), function (e) {
              if (e) {
                if (e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap) return;
                i(t = e);
              } else o();
            };
          }

          t.exports = function (t, e) {
            (e = e || {}).singleton || "boolean" == typeof e.singleton || (e.singleton = (void 0 === i && (i = Boolean(window && document && document.all && !window.atob)), i));
            var n = r(t = t || [], e);
            return function (t) {
              if (t = t || [], "[object Array]" === Object.prototype.toString.call(t)) {
                for (var i = 0; i < n.length; i++) {
                  var o = s(n[i]);
                  a[o].references--;
                }

                for (var h = r(t, e), l = 0; l < n.length; l++) {
                  var d = s(n[l]);
                  0 === a[d].references && (a[d].updater(), a.splice(d, 1));
                }

                n = h;
              }
            };
          };
        }
      },
      e = {};

    function n(i) {
      if (e[i]) return e[i].exports;
      var o = e[i] = {
        id: i,
        exports: {}
      };
      return t[i](o, o.exports, n), o.exports;
    }

    return n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, {
        a: e
      }), e;
    }, n.d = function (t, e) {
      for (var i in e) {
        n.o(e, i) && !n.o(t, i) && Object.defineProperty(t, i, {
          enumerable: !0,
          get: e[i]
        });
      }
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n(667);
  }();
});



//////////////////
// WEBPACK FOOTER
// ./~/vue-puzzle-vcode/dist/main.js
// module id = 3009
// module chunks = 1